import Button from "src/components/Button";
import Input from "src/components/Input";
import Label from "src/components/Label";

import pkg from "../../../../package.json";

interface ITwoFAFormProps {
  twoFACode: string;
  setTwoFACode: (code: string) => void;
  submitTwoFA: () => void;
}

export const TwoFAForm: React.FC<ITwoFAFormProps> = ({
  twoFACode,
  setTwoFACode,
  submitTwoFA
}) => (
  <form
    onSubmit={(e) => {
      e.preventDefault();
      submitTwoFA();
    }}
  >
    <div className="sign-in-header">
      <div className="sign-in-headline">Please enter your 2FA code</div>
    </div>
    <Input
      value={twoFACode}
      onChange={(e) => setTwoFACode(e.target.value)}
      label="2FA Code"
      placeholder="Enter your 2FA code"
      required
      block
      data-cy="login-2fa"
    />
    <div className="sign-in-button">
      <Button
        label="Sign In"
        color="teal"
        submit
        block
        data-cy="login-submit"
      />
    </div>
    <div style={{ textAlign: 'right' }}>
      <Label color="teal" label={`Version: ${pkg.version}`} />
    </div>
  </form>
);
